import { getLocale } from "../runtime";

const da_blacklistmessages = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poff!,Frihed!,Lettelse!,Borte for altid!,Hej!,Sayonara!,Endelig!,Vokse!,Godt at dette er slut!,Frielse!,Slipp!,Aldrig mere!,Ny start!,Slipp taget!`
};

const en_blacklistmessages = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poof!,Freedom!,Relief!,Gone forever!,Bye bye!,Sayonara!,Finally!,Thrive!,Good riddance!,Liberation!,Released!,No more!,Moving on!,Fresh start!,Let go!`
};

const es_blacklistmessages = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poff!,Libertad!,Alivio!,¡Adiós!,Chao!,Sayonara!,¡Por fin!,¡A crecer!,¡Qué bien!,¡Libre!,¡Soltar!,¡Nunca más!,¡Nuevo inicio!,¡Adelante!`
};

const fi_blacklistmessages = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poff!,Vapautus!,Helpotus!,Hei hei!,Hei!,Sayonara!,Lopulta!,Kasvaa!,Hyvä niin!,Vapaus!,Irti!,Ei enää!,Uusi alku!,Päästä irti!`
};

const nb_blacklistmessages = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poff!,Frihet!,Lettelse!,Borte for alltid!,Hei!,Sayonara!,Endelig!,Vokse!,Godt at dette er slutt!,Frielse!,Slipp!,Aldri mer!,Ny start!,Slipp taket!`
};

const sv_blacklistmessages = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poff!,Äntligen fri!,Vilken lättnad!,Borta för alltid!,Hejdå!,Sayonara!,Äntligen!,Nu kör vi!,Skönt att slippa!,Befrielse!,Nu släpper vi!,Aldrig mer!,Nystart!,Släpp taget!`
};

const blacklistmessages = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_blacklistmessages(inputs)
	if (locale === "en") return en_blacklistmessages(inputs)
	if (locale === "es") return es_blacklistmessages(inputs)
	if (locale === "fi") return fi_blacklistmessages(inputs)
	if (locale === "nb") return nb_blacklistmessages(inputs)
	if (locale === "sv") return sv_blacklistmessages(inputs)
	return "blacklistMessages";
};

export { blacklistmessages as "blacklistMessages" };